
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class POCreatedBanner extends Vue {
  @Prop({ required: true }) public readonly poNumber!: string;
  @Prop({ default: '' }) public readonly supplierName!: string;
}
